module.exports = __webpack_public_path__ + "img/product-preview-75.0a5a915.png";